"use client";
import { Image } from "@chakra-ui/react";
import React from "react";

export function NYSACC(props: any): React.ReactElement {
  return (
    <>
      <Image
        src="https://nysacc.org/wp-content/uploads/NYSACC_Logo2_300x259.jpg"
        alt="New York State Association of Conservation Commissions"
      />
    </>
  );
}

export default NYSACC;
